// App constants
export class AppConstants {
    public static encodedUrlToken: string = '_enc_';
    public static PaymentMethod_Check: string = 'CHK';
}
